module.exports = __webpack_public_path__ + "img/draw-rules-right.af4aa469.png";